import React, { useRef,useEffect, useLayoutEffect } from 'react'
import SlideItem from './SlideItem'
import bottle1 from '../../assets/images/slide-1-bottle.png'
import bottle2 from '../../assets/images/slide-2-bottel.png'
import bottle3 from '../../assets/images/slide-3-bottle.png' 
import bottleBase from '../../assets/images/bottle-base.png' 
import {gsap, ScrollTrigger} from 'gsap/all'
import useLocoScroll from '../../hooks/useLocoScroll'
import { timeToReadyTl } from '../../utils/gsapService'

const slideData = [ 
    {
        title:"X Series",
        description:"Lorem ipsum dolor sit amet consectetur. Pulvinar mauris fames cursus amet fames eget accumsan aliquet. Id imperdiet feugiat lacinia nunc adipiscing. Faucibus euismod ut volutpat aliquet velit odio imperdiet. Nunc massa mattis etiam justo eu elementum pellentesque eu. Laoreet et consequat in facilisis. ",
        btnName:"BUY NOW",
        btnLink:"#",
        bottleSrc:bottle1,
        bottleBase:bottleBase
    },
    {
        title:"Noble Rot",
        description:"Lorem ipsum dolor sit amet consectetur. Pulvinar mauris fames cursus amet fames eget accumsan aliquet. Id imperdiet feugiat lacinia nunc adipiscing. Faucibus euismod ut volutpat aliquet velit odio imperdiet. Nunc massa mattis etiam justo eu elementum pellentesque eu. Laoreet et consequat in facilisis. ",
        btnName:"BUY NOW",
        btnLink:"#",
        bottleSrc:bottle2,
        bottleBase:bottleBase
    },
    {
        title:"Abstrakt",
        description:"Lorem ipsum dolor sit amet consectetur. Pulvinar mauris fames cursus amet fames eget accumsan aliquet. Id imperdiet feugiat lacinia nunc adipiscing. Faucibus euismod ut volutpat aliquet velit odio imperdiet. Nunc massa mattis etiam justo eu elementum pellentesque eu. Laoreet et consequat in facilisis. ",
        btnName:"BUY NOW",
        btnLink:"#",
        bottleSrc:bottle3,
        bottleBase:bottleBase
    },
]

gsap.registerPlugin(ScrollTrigger);

export default function Slide() { 

    
    const slideContainer = useRef(null);
    const slideWrapper = useRef(null);
    
    useLocoScroll(false);

    useLayoutEffect(() => { 
        const slidelength = slideWrapper.current.offsetWidth - window.innerWidth;
        let slideTl = gsap.timeline();
        const startingTimer = setTimeout(() => { 
            slideTl.to(slideWrapper.current, {  
                "--x":"-100%",
                "--vw":"100vw",
                scrollTrigger:{ 
                    trigger:slideContainer.current,
                    scroller:"#main-container",
                    start:()=>{
                        return `bottom +=${window.innerHeight}`
                    },   
                    end:()=> `+=${slidelength}`,  
                    pin:true,
                    scrub:true,   
                    // markers:true 
                }
            })
            ScrollTrigger.refresh(); 
        }, timeToReadyTl.firstDelay);
        ScrollTrigger.refresh();
        
        return ()=>{ 
            clearTimeout(startingTimer);
            slideTl.kill();
        }

    }, [])

    return (
        <section className="slide-section horizontal-scroll-slide bg-body">
            <div className="slide-container" ref={slideContainer}>
                <div className="slide-wrapper" ref={slideWrapper}>  
                    <div className="first-slide-item"><h2 className="title-lg">Our Line</h2></div>
                    {
                        slideData.map((data, index)=>{
                            return(
                                <SlideItem
                                    title={data.title} 
                                    description={data.description} 
                                    btnName={data.btnName} 
                                    btnLink={data.btnLink} 
                                    bottleSrc={data.bottleSrc} 
                                    bottleBaseSrc={data.bottleBase} 
                                    slideItemClassName={`slide-item-${index}`}
                                    key={index}
                                ></SlideItem> 
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}
